@if (isBusy) {
    <ws-busy-indicator></ws-busy-indicator>
}
@if (schedule) {
    <div
        (click)="onScheduleClicked($event)"
        [ngClass]="{ 'active-schedule': isScheduleActive(), 'inactive-schedule': scheduleFilterId && !isScheduleActive() }">
        @if (canExpand) {
            <div class="toggle-switch">
                @if (!isExpanded) {
                    <button class="ace-btn btn-link btn-sm" title="Expand" (click)="toggleIsExpanded($event)">
                        <i class="fa fa-plus"></i>
                    </button>
                }
                @if (isExpanded) {
                    <button class="ace-btn btn-link btn-sm" title="Collapse" (click)="toggleIsExpanded($event)">
                        <i class="fa fa-minus"></i>
                    </button>
                }
            </div>
        }
        @if (schedule.formRevisionScheduleId && !scheduleForNonReportableAssets) {
            <div class="header">
                <div class="schedule-title">{{ schedule.name }} {{ schedule.description ? '(' + schedule.description + ')' : '' }}</div>
                @if (schedule.depreciationTableId) {
                    <div class="factor-table-title small">{{ schedule.depreciationTableName }}
                        ({{ schedule.depreciationTableLife }} year life)
                    </div>
                }
            </div>
        }
        @if (!isExpanded) {
            <div class="form-values values-summary">
                <div class="form-value-group">
                    <div class="form-value-label">Assets</div>
                    <div class="form-value">{{ (schedule.assetCount || 0) | number }}</div>
                </div>
                <div class="form-value-group">
                    <div class="form-value-label">Cost</div>
                    <div class="form-value">{{ (schedule.cost || 0) | currency: 'USD' : 'symbol' }}</div>
                </div>
                <div class="form-value-group">
                    <div class="form-value-label"><span>Value</span></div>
                    <div class="form-value">
                        @if (schedule.isReportable) {
                            <span>{{ (schedule.reportedValue || 0) | currency: 'USD' : 'symbol' }}</span>
                        }
                        @if (!schedule.isReportable) {
                            <span>N/A</span>
                        }
                    </div>
                </div>
            </div>
        }
        @if (isExpanded) {
            <div class="form-values values-detail">
                <table class="table table-hover table-condensed ws-no-margin">
                    <thead>
                        <tr>
                            <th>Sch. Year</th>
                            <th class="ws-text-align-right">Assets</th>
                            <th class="ws-text-align-right">Cost</th>
                            @if (schedule.depreciationTableId) {
                                <th>Factor</th>
                            }
                            <th class="ws-text-align-right">Rep. Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (detail of scheduleDetails; track detail) {
                            <tr
                                (click)="onScheduleDetailClicked($event, detail)"
                                [ngClass]="{ 'active-factor': isScheduleDetailActive(detail) }">
                                <td>{{ detail.year }}</td>
                                <td class="ws-text-align-right">{{ detail.assetCount | number }}</td>
                                <td class="ws-text-align-right">{{ (detail.cost || 0) | currency: 'USD' : 'symbol' }}</td>
                                @if (schedule.depreciationTableId) {
                                    <td>{{ (detail.depreciationFactor * 100) | number: '1.2-5' }}</td>
                                }
                                <td class="ws-text-align-right">{{ (detail.reportedValue || 0) | currency: 'USD' : 'symbol' }}</td>
                            </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr class="ws-font-weight-bold">
                            <td>Total</td>
                            <td class="ws-text-align-right">{{ (schedule.assetCount || 0) | number }}</td>
                            <td class="ws-text-align-right">{{ (schedule.cost || 0) | currency: 'USD' : 'symbol' }}</td>
                            @if (schedule.depreciationTableId) {
                                <td></td>
                            }
                            <td class="ws-text-align-right">{{ (schedule.reportedValue || 0) | currency: 'USD' : 'symbol' }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        }
    </div>
}
